module.exports = __webpack_public_path__ + "img/logo_g3wsuite.png";